import { render, staticRenderFns } from "./ProvidersRoutePage.vue?vue&type=template&id=28fa5878&"
import script from "./ProvidersRoutePage.vue?vue&type=script&lang=js&"
export * from "./ProvidersRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports